import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { Party } from 'app/event/models/party';
import { SummaryRecordTypeEnum } from 'app/event/models/summary-record-type.enum';
import { EventUtils } from 'app/event/utils/event-utils';
import { Observable } from 'rxjs/Observable';
import { MenuStore } from '../../../menus/service/menu.store';
import { AuthenticationStore } from '../../../permission/services/authentication.store';
import { OnyxEvent } from '../../models/event';
import { EventStore } from '../../service/event.store';
import { ReservationCompareStore } from '../../service/reservation-compare-store';
import { EnvironmentConfiguration } from '../../../environment/services/environment.configuration';

@Component({
  selector: 'pioneer-vendor-rsvp-card',
  templateUrl: './vendor-rsvp-card.component.html',
  styleUrls: ['./vendor-rsvp-card.component.css']
})
export class VendorRsvpCardComponent implements OnInit {

  public onyxEvent: OnyxEvent;

  @Input() vendors: Party[];

  @Input() vendor: Party;

  vendorForm: FormGroup;

  private readonly vendorFormValidators = {};

  public headerRecordType: SummaryRecordTypeEnum;

  disableCompareButton$: Observable<boolean>;
  showReservationCompareSummary$: Observable<boolean>;
  areRsvpsPresent$: Observable<boolean>;

  isInDetail: boolean;

  displayAddRsvp: boolean;

  public imagesUrl= '';

  constructor(
    private eventStore: EventStore,
    private reservationCompareStore: ReservationCompareStore,
    private menuStore: MenuStore,
    private router: Router,
    private authStore: AuthenticationStore,
    private formBuilder: FormBuilder,
    private environment: EnvironmentConfiguration
  ) { }

  ngOnInit(): void {
    this.imagesUrl = this.environment.onyxGPImagesCommonDataUrl;

    this.eventStore.selectedEvent.subscribe(event => this.onyxEvent = event);
    if (this.onyxEvent) {
      this.menuStore.setPageHeader(EventUtils.getEventName(this.onyxEvent, this.authStore.isAgencyUser())
        , this.onyxEvent.eventProperty.subscriber);
    }

    this.disableCompareButton$ = this.reservationCompareStore.isVendorCompareListEmpty(this.vendor.eventPartyId);
    this.showReservationCompareSummary$ = this.reservationCompareStore.getShowReservationCompareSummary();
    this.areRsvpsPresent$ = this.reservationCompareStore.areVendorRsvpsPresent(this.vendor.eventPartyId);

    this.checkDetailPath(this.router.url);

    this.displayAddRsvp = this.authStore.hasPermission(['AddRsvp', 'UploadRsvp']);

    if (this.vendors) {
      if (this.vendors.length === 1) {
        this.vendor.isExpanded = true;
      }
    }

    this.createForm();

    this.headerRecordType = SummaryRecordTypeEnum.RSVP;

  }

  private createForm() {
    this.vendorForm = this.formBuilder.group({
      vendorName: this.vendor.name,
      vendorAdress: this.getVendorAddress(),
      vendorState: this.vendor.state,
      vendorZip: this.vendor.postalCode
    }, this.vendorFormValidators);
  }

  private getVendorAddress(): string {
    return this.vendor.line1;
  }

  navigateTo(path: string) {
    this.checkDetailPath(path);
    this.router.navigate([path]);
  }

  checkDetailPath(path: string) {
    this.isInDetail = path.indexOf('/detail') !== -1;
  }

  public onCardExpandClicked(event: Event, eventPartyId: number
                           , chain: string, brand: string, propertyId: string, expanded: boolean): void {
    event.preventDefault();
    if (eventPartyId) {
      this.vendors.filter(ve => ve.eventPartyId === eventPartyId).forEach(x => {
        x.isExpanded = expanded;
      });
    } else {
      this.vendors.filter(ve => ve.chain === chain && ve.brand === brand && ve.propertyId === propertyId).forEach(x => {
        x.isExpanded = expanded;
      });
    }
    if (expanded && this.vendors.length > 1) {
      this.disableOthers(eventPartyId, chain, brand, propertyId);
    }
  }

  private disableOthers(eventPartyId: number, chain: string, brand: string, propertyId: string): void {
    if (eventPartyId) {
      this.vendors.filter(ve => ve.eventPartyId !== eventPartyId).forEach(x => {
        x.isExpanded = false;
      });
    } else {
      this.vendors.filter(ve => ve.chain !== chain || ve.brand !== brand || ve.propertyId !== propertyId).forEach(x => {
        x.isExpanded = false;
      });
    }
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/rsvp/vendor-rsvp-card/vendor-rsvp-card.component.ts